export default {
  session: null,
}
